import DEFAULT_IMAGE_SMALL from 'public/static/images/default/play_default_224x126.jpg';
import DEFAULT_IMAGE_MEDIUM from 'public/static/images/default/play_default_480x270.jpg';
import DEFAULT_IMAGE_LARGE from 'public/static/images/default/play_default_650x365.jpg';
import env from '../env';

export { DEFAULT_IMAGE_SMALL, DEFAULT_IMAGE_MEDIUM, DEFAULT_IMAGE_LARGE };

export const formatUrl = (urlTemplate: string, format: string): string => {
    try {
        return urlTemplate.replace('{format}', format);
    } catch (err) {
        return DEFAULT_IMAGE_SMALL;
    }
};

const getBaseUrl = (): string => {
    if (env.IMAGE_ENV === 'stage') {
        return 'https://www.svtstatic.se/image-stage/';
    }

    return 'https://www.svtstatic.se/image/';
};

export const isImageProxyTemplate = (urlTemplate: string): boolean => {
    if (!urlTemplate) {
        return false;
    }

    return urlTemplate.startsWith(`${getBaseUrl()}{type}/{size}/`);
};

export const formatImageProxyUrl = (urlTemplate: string, type: string, size: number, extras = ''): string => {
    try {
        return urlTemplate
            .replace('{type}', type)
            .replace('{size}', size.toString())
            .replace('{extras}', extras ? `&${extras}` : '');
    } catch (err) {
        return DEFAULT_IMAGE_SMALL;
    }
};

export const createImageProxyTemplate = (id: string, timestamp: number): string => {
    const timestampPart = timestamp ? `/${timestamp}` : '';
    const proxyURL = `${getBaseUrl()}{type}/{size}/${id}${timestampPart}?format=auto&chromaSubSampling=false&enableAvif=true`;

    return `${proxyURL}{extras}`;
};

export const createImageProxyUrl = (
    id: string,
    timestamp: number,
    type: string,
    size: number,
    extras?: string
): string => formatImageProxyUrl(createImageProxyTemplate(id, timestamp), type, size, extras);

export const contentoImageUrl = (
    image: any,
    type: string,
    size: number,
    fallback?: string,
    extras?: string
): string => {
    if (!image) {
        return fallback;
    }

    return createImageProxyUrl(image.id, image.changed, type, size, extras);
};
